<script>
    import IfeCard from "./IfeCard.svelte";
    import { selectedField } from "../Stores";

    export let fieldCards;
</script>

<ul cy_data="ife_card_list">
    {#each fieldCards as fieldCard}
        {#if fieldCard.field === $selectedField || !$selectedField}
            <IfeCard {fieldCard} />
        {/if}
    {/each}
</ul>
